<template>
    <v-btn v-if="showsChargeBtn" :disabled="chargeDisabled" text block tile color="primary" class="caption point-btn" height="54px" v-bind="{ loading }" @click="charge">지급하기</v-btn>
    <v-btn v-else text block tile color="secondary" class="caption point-btn" height="54px" v-bind="{ loading }" :to="pointTo">{{ pointText }}</v-btn>
</template>

<script>
import api from "@/api";
import { FORM_STATES__POINT_ORDER_ACCOUNT, initPointForm__account } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: initPointForm__account },
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        showsChargeBtn() {
            return !this.value.point;
        },
        chargeDisabled() {
            return [FORM_STATES__POINT_ORDER_ACCOUNT.PURCHASE_CANCELD.value].includes(this.value.state);
        },
        pointText() {
            const { amount, createdAt } = this.value.point || {};

            let text = "";

            if (![null, undefined].includes(amount)) {
                text += `포인트: ${amount?.format?.() || amount || 0}원`;
            }
            if (text) text += "\n";
            if (createdAt) text += `지급일자: ${createdAt?.toDateTime?.() || createdAt || "-"}`;

            return text;
        },
        pointTo() {
            const { _point, point: { _user } = {} } = this.value;

            return {
                path: "/console/user-points",
                query: { _user, _point },
            };
        },
    },
    methods: {
        async charge() {
            const form = {
                _user: this.value.writer?._id,
                _form: this.value._id,
                amount: this.value?.meta?.amount,
                remark: "포인트 충전",
            };
            if (!confirm(`포인트를 지급하시겠습니까?\n\n사용자: ${this.value.writer?.username} / ${this.value.writer?.name}\n포인트: ${form.amount?.format?.() || 0}원`)) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                const { point } = await api.console.users.points.post(form);
                alert("지급되었습니다");
                this.$emit("update", { ...this.value, _point: point._id, point });
                this.$emit("search");
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>


<style lang="scss" scoped>
.point-btn {
    ::v-deep {
        .v-btn__content {
            display: block;
            text-align: initial;
            white-space: pre-line;
            text-transform: initial;
        }
    }
}
</style>